import React, { FC, ReactNode } from 'react';
import { Text } from '../Text';
import { ITooltipProps, Tooltip } from '../Tooltip/Tooltip';
import { Icon } from '../Icon';
import { Box } from '../Box';
import { TTextSize } from '../Text/models';
import { IDefaultComponentProps } from '@src/models/props';
import { TMargin } from '@src/models/adaptive';

import styled from './InputLabel.module.scss';

export interface IInputLabelProps extends IDefaultComponentProps {
  content?: string | ReactNode;
  /**
   * Если указать false, то красная звездочка не будет выведена даже,
   * если required валидатор будет стояит - дизайнеры иногда хотят убрать с форм звездочки
   */
  required?: boolean;
  tooltip?: ITooltipProps;
  size?: TTextSize;
}

/**
 * Лейбл для инпутов
 */
export const InputLabel: FC<IInputLabelProps> = ({ content, required, tooltip, size = 'secondary' }) => {
  const isSmallText = !size || size == 'primary' || size == 'secondary';
  const marginTop: TMargin | undefined = isSmallText ? undefined : 16;
  const marginBottom: TMargin | undefined = isSmallText ? undefined : 8;
  return (
    <>
      {content && (
        <Box alignItems={'center'} marginBottom={marginBottom} marginTop={marginTop}>
          <Text id="content" className={styled.root} size={size}>
            {content}
            {required && (
              <Text id="required" tag={'span'} color={'secondaryRed'}>
                *
              </Text>
            )}
          </Text>
          {tooltip && (
            <Box marginLeft={4}>
              <Tooltip {...tooltip}>
                <Box className={styled.tooltip}>
                  <Icon size={12} view={'basicBlack'} name={'question'} />
                </Box>
              </Tooltip>
            </Box>
          )}
        </Box>
      )}
    </>
  );
};
